import React from 'react'
import PropTypes from 'prop-types'

import Statistic from './Statistic'

const OverallStatistics = props => {
  const { atrisk, average, excellent } = props.statistics

  return (
    <div className="overall-statistics">
      <Statistic
        title="Total Students"
        value={props.studentCount}
        color="#D6E1FF"
        textColor="#0068A8"
        iconClass="fal fa-users"
        link={`/instructor/progress/${props.coursenum}`}
        loading={false}
        error={false}
        className="statistic"
      />
      <Statistic
        title="At-Risk Students"
        value={atrisk}
        color="#FFD6D6"
        textColor="#8F0000"
        iconClass="fad fa-exclamation-triangle"
        link={`/instructor/progress/${props.coursenum}//atrisk`}
        loading={props.loading}
        error={props.error}
        className="statistic"
      />
      <Statistic
        title="Average Students"
        value={average}
        color="#FFF4F0"
        textColor="#BF3300"
        iconClass="fal fa-star"
        link={`/instructor/progress/${props.coursenum}//average`}
        loading={props.loading}
        error={props.error}
        className="statistic"
      />
      <Statistic
        title="Excellent Students"
        value={excellent}
        color="#D4F7E2"
        textColor="#1A7540"
        iconClass="fad fa-stars"
        link={`/instructor/progress/${props.coursenum}//excellent`}
        loading={props.loading}
        error={props.error}
        className="statistic"
      />
    </div>
  )
}

OverallStatistics.propTypes = {
  coursenum: PropTypes.string.isRequired,
  studentCount: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  statistics: PropTypes.object.isRequired,
}

export default OverallStatistics
